import TrailerReports from './tables/safety/trailers';
import TruckReports from './tables/safety/trucks';

const SafetyBriefing = () => {
    
    return (
        <>
            <div className="main-container">
                <TrailerReports />
                <TruckReports />
            </div>
            {/* <div className="multi-button-hover-container">
                {
                    terminals.map((terminal) => (
                        <button
                            key={terminal.id}
                            active={currentTerminal.id === terminal.id ? 'true' : 'false'}
                            onClick={() => dispatch(setCurrentTerminal(terminal))}
                            style={{ color: ""}}
                            className={`hovering-button ${terminal.short_form_name}`}
                        >
                            {terminal.name}
                        </button>
                    ))
                }
            </div> */}
        </>
    );
};

export default SafetyBriefing;
